import {
  PaymentMethodType,
  TranslatedPaymentMethodType
} from "@/common/types/PaymentMethod.types";

export const paymentMethodOptions = [
  {
    key: PaymentMethodType.CREDIT_CARD,
    text: TranslatedPaymentMethodType.CREDIT_CARD
  },
  {
    key: PaymentMethodType.INVOICE_DEBIT,
    text: TranslatedPaymentMethodType.INVOICE_DEBIT
  },
  {
    key: PaymentMethodType.PIX,
    text: TranslatedPaymentMethodType.PIX
  }
];
